<template>
    <div class="ppv2-w-full">
        <!-- Header-->
        <slot name="overlay-header"></slot>
        <!-- Fin Header -->

        <div class="content-side pt-1">
            <div class="block-transparent row mb-0 block-enc-resp">
                <div class="col-xs-12 col-lg-6">
                    <div class="block block-transparent pt-0 px-4t px-0 mb-0">
                        <div class="block-content pt-0 overflow-hidden mb-0">
                            <!-- Payment-->
                            <slot name="payment-component"></slot>
                            <!-- Fin Payment -->
                        </div>
                    </div>
                    <div class="block block-transparent pt-0 px-4t px-3 mb-0">
                        <div class="block-content pt-0 mb-0">
                            <!-- actions btns-->
                            <slot name="deposits"></slot>
                            <!--  actions btns -->
                        </div>
                    </div>
                    <div class="block block-transparent pt-0 px-4t px-3 mb-0">
                        <div class="block-content pt-0 overflow-hidden mb-0">
                            <!-- actions btns-->
                            <slot name="security"></slot>
                            <!--  actions btns -->
                        </div>
                    </div>
                    <div class="block block-transparent pt-0 px-4t px-3 mb-0">
                        <div class="block-content pt-0 overflow-hidden mb-0">
                            <!-- actions btns-->
                            <slot name="actions-buttons"></slot>
                            <!--  actions btns -->
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-lg-6 part2-enc-rsep">
                    <!-- Card-->
                    <slot name="card-component"></slot>
                    <!-- Fin Card -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
<style scoped>
.nav-tabs .nav-link {
    margin-bottom: -1px;
    background: none;
    font-weight: 400;
    font-size: 16px !important;
    color: #94a3b8;
    border-radius: 0px !important;
    margin-bottom: 5px;
}
.nav-tabs .nav-link {
    font-weight: 400 !important;
}
.nav-link {
    padding: 11px 15px 11px 15px;
}
.bloc-button {
    display: flex !important;
    justify-content: end;
    gap: 8px;
}
</style>
